/* eslint-disable react/button-has-type */
import React from "react";
import clx from "classnames";
import Icon, { Icons } from "../../Icon/Icon";
import styles from "../styles/Button.module.css";
import Spinner from "../../Spinner/Spinner";

export const Variants = {
    none: styles.buttonNoStyle,
    emphasis: "type-emphasis !font-bold !border-0",

    primary: styles.ButtonPrimary,
    secondary: styles.ButtonSecondary,
    borderedWhite: styles.ButtonBorderedWhite,
    borderedMint: styles.ButtonBorderedMint,

    primaryYellow: styles.ButtonPrimaryYellow,
    primaryDisabled: styles.ButtonPrimaryDisabled,
};

export const Sizes = {
    none: "",
    small: "px-0.5 py-0.25",
    default: "px-1 py-0.5",
    large: "px-1.5 py-0.75",
};

interface Props extends Pick<React.ButtonHTMLAttributes<HTMLButtonElement>, "className" | "disabled" | "onClick" | "title"> {
    children?: React.ReactNode;
    variant?: keyof typeof Variants;
    size?: keyof typeof Sizes;
    type?: "button" | "submit" | "reset";
    icon?: Icons;
    loading?: boolean;
}

/**
 * Button component
 * Used for rendering all styles of our buttons
 */
const Button = ({
    children,
    type = "button",
    variant = "primary",
    size = "default",
    icon,
    className,
    disabled = false,
    loading = false,
    ...rest
}: Props) => {
    const cn = clx(variant === "none" ? "" : styles.button, Variants[variant], Sizes[size], className, {
        "cursor-not-allowed": disabled && !loading,
        "cursor-wait": loading,
    });

    return (
        <button type={type} className={cn} disabled={loading || disabled} {...rest}>
            {children}
            {icon && (
                <Icon
                    icon={icon}
                    className={clx("button_icon", {
                        invisible: loading,
                    })}
                />
            )}
            {loading ? (
                <span className={styles.buttonLoading}>
                    <Spinner color="" />
                </span>
            ) : null}
        </button>
    );
};

export default Button;
